export default [
    {
      name: "bg",
      type: "texture",
      path: "./textures/bg1.png",
    },
    {
      name: "spidernet",
      type: "spidernet",
      path: "./textures/spidernet.png",
    },
    {
      name: "pumpkin",
      type: "gltf",
      path: "./models/pumpkin2.glb",
    },
  ]; 